module.exports = __webpack_public_path__ + "static/media/expert-google-plus-icon.df27b362.svg";